import { Box, Typography } from '@mui/material';
import { prepareHtml } from '../../utils/htmlUtils';

const fontFamily = '"Inter", sans-serif';

const ProposalViewJobOverview = ({ description }) => {
  if (!description) return null;

  return (
    <Box sx={{ mb: 4, px: 2 }}>
      {/* Header */}
      <Box sx={{ display: 'inline-block', mb: 2 }}>
        <Box
          sx={{
            backgroundColor: '#0d3c61',
            color: '#fff',
            px: 2,
            py: 0.75,
          }}
        >
          <Typography
            sx={{
              fontFamily,
              fontWeight: 600,
              fontSize: 14,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
            Project Overview
          </Typography>
        </Box>
      </Box>
      
      {/* Content */}
      <Box
        dangerouslySetInnerHTML={{ __html: prepareHtml(description) }}
        sx={{
          fontFamily,
          fontWeight: 400,
          fontSize: 13,
          color: '#333',
          lineHeight: 1.7,
          wordBreak: 'break-word',
          '& p': { margin: 0 },
          '& div': { margin: 0 },
        }}
      />
    </Box>
  );
};

export default ProposalViewJobOverview;
